import { render, staticRenderFns } from "./NavigationBarTab.vue?vue&type=template&id=2957234b&scoped=true"
import script from "./NavigationBarTab.vue?vue&type=script&lang=js"
export * from "./NavigationBarTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2957234b",
  null
  
)

export default component.exports